import React, { useState} from 'react';
import {GoogleMap, withScriptjs, withGoogleMap, Marker, InfoWindow} from "react-google-maps";
import  * as incidentData from "../../data/test_incidents.json"
import mapStyles from "../Map/mapStyles";
import "../../stylesheets/map-style.css";


function Map() {
  const [selectedIncident, setSelectedIncident] = useState(null);


  return (
    <GoogleMap
      defaultZoom={14}
      defaultCenter={{lat: 41.792162, lng: -87.599970}}
      defaultOptions={{styles: mapStyles}}
    >
      {incidentData.incidents.map((incident) => (
        <Marker
        icon={{
          url: '/Theft Icon.svg',
          scaledSize: new window.google.maps.Size(30,30)
        }}
        key={incident.id}
        position={{lat: incident.lat, lng: incident.lng}}
        onClick={() => {
          setSelectedIncident(incident);
        }}
        />
      ))}

      {selectedIncident && (
        <InfoWindow
          position={{lat: selectedIncident.lat, lng: selectedIncident.lng}}
          onCloseClick={() => {
            setSelectedIncident(null);
          }}
        >
            <div>
              <h3>{selectedIncident.type}</h3>
              <p>{selectedIncident.time}</p>
            </div>

        </InfoWindow>
      )}
    </GoogleMap>
  );
}

var mapsURL = `https://maps.googleapis.com/maps/api/js?key=${ process.env.REACT_APP_GOOGLE_KEY }`;


const WrappedMap = withScriptjs(withGoogleMap(Map));

const Landing = () => (
  <div class="map_box" >
        <WrappedMap
        googleMapURL={mapsURL}
        loadingElement={<div style={{height: "100%"}} />}
        containerElement={<div style={{height: "100%"}} />}
        mapElement={<div style={{height: "100%"}} />}
        />
    </div>
);
export default Landing;
